import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index'
import './assets/flexible.f.js' // 引入自适应
import './assets/less/common.less'
import mixin from './assets/mixin'
import dateUtils from './assets/date-utils'
import stat from 'vue-plugin-stat'
import report, { statisticsReport } from './services/stat'
import VConsole from 'vconsole'
import beforeInstance from './assets/initJsbridge' // 注册js方法供原生调用
import './components'
import { Picker, Popup, Area, PullRefresh, CountDown, Field, Form, Uploader, Cell } from 'vant'
import showApiBackHome from '@/assets/directive/showApiBackHome'

import { getKey, addCookie } from '@/assets/utils'

import exposure from '@/plugins/exposure/index.es6.js'
import pageleave from '@/plugins/exposure/pageleave.es6.js'

import filters from '@/assets/filters'
const { version } = require('../package.json')

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
// 把version 写入cookie
addCookie('$app_version', version)


// 阿里云ARMS监控
// 文档 https://help.aliyun.com/zh/arms/browser-monitoring/developer-reference/sdk-reference?spm=a2c4g.11186623.0.0.664a5846rQoGbx
const BrowserLogger = require('alife-logger')
if (process.env.NODE_ENV === 'production' && process.env.VUE_APP_ISPRODUCTION === 'true') {
  // eslint-disable-next-line no-unused-vars
  const __bl = BrowserLogger.singleton(
    {
      pid: 'iil3270zfj@668b12f8bc95fec',
      appType: 'web',
      imgUrl: 'https://arms-retcode.aliyuncs.com/r.png?',
      behavior: true, // 是否为了便于排查错误而记录报错的用户行为
      disableHook: true, // 禁用AJAX请求监听
      enableLinkTrace: true
    }
  )

  __bl.setConfig({
    ignore: {
      ignoreUrls: [],
      ignoreApis: [],
      ignoreErrors: [
        /^Script error\.?$/,
        /^.*findFunction.*$/,
        /^.*stayAlert.*$/,
        /^.*refresh.*$/,
        /^.*webViewWillGoPause.*$/,
        /^.*ResizeObserver.*$/,
        /^.*giveTokenToH5.*$/,
        /^.*getH5TopHeight.*$/,
        /^.*webViewWillGoPause.*$/,
        /^.*webViewWillGoResume.*$/,
        /^.*setWebViewFlag.*$/,
        /^.*appBackground.*$/,
        /^.*$$.*$/,
        /^.*onKeyboardChange.*$/,
        /^.*reload is not defined.*$/,
        /^.*owlJsBridge.sendResult.*$/,
        /^.*mmLoanEnterForeground.*$/
      ]
    }
  })
  window.__bl = __bl
} else {
  const __bl = BrowserLogger.singleton(
    {
      pid: 'iil3270zfj@c75202ef628d018',
      appType: 'web',
      imgUrl: 'https://arms-retcode.aliyuncs.com/r.png?',
      sendResource: true,
      enableLinkTrace: true,
      disableHook: true,
      behavior: true
    }
  )
  window.__bl = __bl
}

Vue.config.errorHandler = (err, vm, info) => {
  const error = new Error(err)
  window.__bl && window.__bl.error(error, { filename: `errorHandler: ${vm.$vnode.tag}, ${info}` })
  throw error
}

if (process.env.VUE_APP_ISPRODUCTION === 'false') {
  // eslint-disable-next-line
  new VConsole()
}
const sensors = require('sa-sdk-javascript')
sensors.use(exposure, {
  area_rate: 0,
  stay_duration: 2,
  repeated: true
})
// sensors.use(reg)

/**
 * 页面离开事件埋点 参考 https://github.com/sensorsdata/sa-sdk-javascript/tree/master/dist/web/plugin/pageleave
 */
sensors.use(pageleave, {
  custom_props: {
    // prop1: 'value1'
  },
  heartbeat_interval_time: 5,
  max_duration: 5 * 24 * 60 * 60,
  isCollectUrl: function (url) {
    // url 为要采集页面浏览时长的页面地址。
    return true // 采集
    // return false; // 不采集
  }
})

sensors.init({
  server_url: process.env.VUE_APP_API_SENSORS_SERVER_URL,
  is_track_single_page: true, // 单页面配置，默认开启，若页面中有锚点设计，需要将该配置删除，否则触发锚点会多触发 $pageview 事件
  use_client_time: true,
  send_type: 'ajax',
  heatmap: {
    // 是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
    clickmap: 'default',
    // 是否开启触达图，not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启。
    scroll_notice_map: 'default',
    // 采集所有div点击事件
    collect_tags: {
      div: true
    }
  },
  show_log: localStorage.getItem('show_log') === 'Y'
})

const userInfo = getKey('userInfo')
const phoneNumber = userInfo ? userInfo.mobile : ''
const userId = userInfo ? userInfo.userId : ''

sensors.registerPage({
  gid: getKey('gid'),
  phone_number: phoneNumber,
  channel: getKey('channel_mp') || getKey('appChannel') || getKey('channel') || 'official',
  custId: userId,
  $app_version: getKey('appVersion') || version
})
sensors.quick('autoTrack')
Vue.prototype.$sensors = sensors
window.$sensors = sensors

Vue.directive('showApiBackHome', showApiBackHome)

Vue.use(Picker)
Vue.use(Popup)
Vue.use(Area)
Vue.use(PullRefresh)
Vue.use(CountDown)
Vue.use(mixin)
Vue.use(dateUtils)
Vue.use(Field)
Vue.use(Form)
Vue.use(Uploader)
Vue.use(Cell)
Vue.use(stat, {
  report,
  router
})
Vue.prototype.$statistics = statisticsReport
Vue.config.productionTip = false

beforeInstance(store, () => {
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
})

